import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="mobile-menu">
        <div className="body mobile-contact">
          <Link to="/stake">
            <button className="action button ">
              {/* <img src="/svgs/home.svg" alt=""/> */}
              <p>STAKE</p>
            </button>
          </Link>
          <Link to="/farm">
            <button className="button action">
              {/* <img src="/svgs/about.svg" alt=""/> */}
              <p>FARM</p>
            </button>
          </Link>
          <a href="https://app.testnet.live/">
            <button className="button action">
              {/* <img src="/svgs/about.svg" alt=""/> */}
              <p>SWAP</p>
            </button>
          </a>
          <a href="https://app.testnet.live/#/add/v2/ETH">
            <button className="button action">
              {/* <img src="/svgs/about.svg" alt=""/> */}
              <p>POOL</p>
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default Footer;
